<template lang="pug">
  .component-create-packet-entity-button
    ModalReveal(ref="packetModal", :key="_uid")
      slot(slot="trigger")
        a.fa-stack.fa-lg
          i.fa.fa-circle.fa-stack-2x
          i.fa.fa-plus.fa-stack-1x.fa-inverse
      h2 Create Packet
      PacketForm(v-model="body")
      ActionButton(slot="footer" :action="save") Save
</template>

<script>
import ModalReveal from "../../../foundation/ModalReveal";
import ActionButton from "../../ActionButton";
import KeplerBackofficeSdk from "../../../../../lib/kepler/backoffice";
import MaggieHelper from "../../../../../maggieHelper";
import Editor from "../../Editor.vue";
import PacketForm from "../../../forms/PacketForm.vue";
import {EventBus} from "src/eventBus";

export default {
  name: "CreatePacketReveal",
  components: {
    PacketForm,
    Editor,
    ModalReveal,
    ActionButton
  },
  data() {
    return {
      body: {
        name: null,
        description: "",
        amount: null,
        minutes: null,
        distance: null,
        duration: null,
        max_uses: null,
        status: null
      },
    }

  },
  created() {
  },

  methods: {
    save() {
      return KeplerBackofficeSdk.packets.make(this.body, (data) => {
        MaggieHelper.notification('New packet added ', 'id: ' + data.id)
        EventBus.$emit('reload-list')
        this.$refs.packetModal.close()
      })
    }
  },
  props: ['packet']
}
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// CreatePacketReveal.vue?5d13c3ef